<template>
  <div>

    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>

        <b-row>

          <!-- Branch ID -->
          <b-col cols="3">
            <b-form-group :label="msg('Branch')">
              <v-select
                  v-model="filter.buid"
                  :options="allBranches"
                  class="w-100"
                  label="name"
                  :reduce="(branch) => branch.id"
                  :clearable="false"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("sender") }}</label>
            <b-form-input
                v-model="filter.from"
                class="d-inline-block mr-1"
            />
          </b-col>
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("receiver") }}</label>
            <b-form-input
                v-model="filter.to"
                class="d-inline-block mr-1"
            />
          </b-col>

<!--          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg('Status') }}</label>
            <v-select
                v-model="filter.status"
                :options="messageStatus"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
            />
          </b-col>-->
        </b-row>
      </b-card-body>
    </b-card>

    <!--Card Content-->
    <b-card no-body>
      <b-card-header style="overflow: hidden">
        <span class="card-title m-0"><i class="fas fa-message me-2 mr-1"></i>{{ msg('Messages') }}  </span>
      </b-card-header>

      <!--Table-->
      <messages-table v-bind:filter="filter" ref="messages-table"/>
    </b-card>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MessagesTable from "@/components/tables/MessagesTable.vue";

export default {
  name: "messages",
  components: {MessagesTable},
  data: () => ({
    loadingStats: true,

    filter: {
      from: null,
      to: null,
      status: null,
      buid: null,
      pageUrl: null  // this holds next/previous cursor from API

    },
    stats: {},
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh();
      }
    },
  },
  created() {
    if (this.allBranches.length > 0 && !this.filter.buid) {
      this.filter.buid = this.allBranches[0].id;
    }
  },
  mounted() {
    this.refresh();

  },
  computed: {

    ...mapGetters('reception', ['allStatusMessages']),
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    messageStatus() {
      let $this = this;
      return this.allStatusMessages.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },
  },

  methods: {

    refresh() {
      this.$refs['messages-table'].refresh();
    },
    addNewProvider() {
      // this.$refs.guestFeatureModal.addNewFeature();
    },
  }
}
</script>


<style scoped>

</style>
